import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core'
import {
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidatorFn,
  Validators
} from '@angular/forms'

import { CommonModule } from '@angular/common'
import { environment } from '../../../../../environments/environment'
import { CaseInput } from '../../../interfaces/case-input.interface'
import { FlashMessageService } from '../../../services/flash-message.service'
import { UploadService } from '../../../services/upload.service'
import { ImageComponent } from '../../partials/image/image.component'
@Component({
    selector: 'case-multi-image-input',
    templateUrl: './multi-image-input.component.html',
    styleUrls: ['./multi-image-input.component.scss'],
    standalone: true,
    imports: [CommonModule, ImageComponent, ReactiveFormsModule]
})
export class MultiImageInputComponent implements OnChanges, CaseInput {
  @Input() label: string
  @Input() initialValue: { id: number; path: string }[] = []
  @Input() placeholder: string
  @Input() helpText: string
  @Input() resourceName: string
  @Input() showErrors = false
  @Input() validators: ValidatorFn[] = []
  @Input() uniqueId: string
  @Input() max: number

  @Output() valueChanged: EventEmitter<{ id?: number; path: string }> =
    new EventEmitter()

  @ViewChild('imageInput', { static: false }) imageInputEl: ElementRef

  storagePath: string = environment.storagePath

  form: UntypedFormGroup

  required: boolean
  loading: boolean

  constructor(
    private formBuilder: UntypedFormBuilder,
    private uploadService: UploadService,
    private flashMessageService: FlashMessageService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    // Prevent value from being reset if showErrors changes.
    if (
      Object.keys(changes).length === 1 &&
      Object.keys(changes)[0] === 'showErrors'
    ) {
      return
    }

    this.form = this.formBuilder.group({
      imageArray: this.formBuilder.array(
        this.initialValue.map((image) => ({
          id: image.id,
          path: image.path
        }))
      )
    })

    this.required = this.validators.includes(Validators.required)
  }

  onKeyup(newValue: string) {
    this.valueChanged.emit({ path: newValue })
  }

  // Upload image and update value.
  addImage() {
    this.loading = true
    this.uploadService
      .uploadImage(
        this.resourceName,
        this.imageInputEl.nativeElement.files.item(0)
      )
      .subscribe(
        (res: { path: string }) => {
          this.loading = false

          this.imageArray.push(
            this.formBuilder.control({
              path: res.path
            })
          )

          this.valueChanged.emit(this.form.get('imageArray').value)
        },
        (err) => {
          this.loading = false
          this.flashMessageService.error(
            'There was an error uploading your image.'
          )
        }
      )
  }

  removeImage(index: number) {
    this.imageArray.removeAt(index)

    this.valueChanged.emit(this.form.get('imageArray').value)

    setTimeout(() => {
      this.imageInputEl.nativeElement.focus(), 0
    })
  }

  get imageArray(): UntypedFormArray {
    return this.form.get('imageArray') as UntypedFormArray
  }
}
